import { render, staticRenderFns } from "./leftDetail.vue?vue&type=template&id=43410e73&scoped=true&"
import script from "./leftDetail.vue?vue&type=script&lang=js&"
export * from "./leftDetail.vue?vue&type=script&lang=js&"
import style0 from "./leftDetail.vue?vue&type=style&index=0&id=43410e73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43410e73",
  null
  
)

export default component.exports